.PlayButton {
  img {
    width: 1.2rem;
    height: 1.2rem;
  }
}
